import createNewCharacterCampaignNoteEntry from '../helpers/createNewCharacterCampaignNoteEntry'
import trackCampaignNoteChanges from '../helpers/trackCampaignNoteChanges.js'
import createTempId from '@/helpers/createTempId'
import getTimestamp from '@/helpers/getTimestamp'
//---------------------------
// process add campaign note
//---------------------------
export default function processAddCampaignNote({
  parms = {},
  changed_campaign_notes = [],
  original_campaign_notes = [],
  character = null,
} = {}) {
  console.log('--------------------------------------')
  console.log('IN processAddCampaignNote parms = ', parms)
  //-----------
  // get parms
  //-----------
  // support both { payload: {...} } and a flat payload (e.g. { name: 'Xxx' })
  const payload = parms.payload ?? parms ?? {}

  const id = payload.id ?? createTempId() // temp id for tracking until saved to db and gets real id
  payload.id = id // ensure temp id is in payload for tracking

  const track_campaign_note = payload // includes temp id for tracking
  const updated_at = payload.updated_at ?? getTimestamp() // default to current timestamp on add
  const note = payload.value ?? ''

  const character_id = character?.id ?? null

  console.log('campaign note character_id = ', character_id)
  console.log('CAMPAIGN NOTE TO ADD = ', track_campaign_note)
  //-------------------------------
  // update tracking with new count
  //-------------------------------
  console.log('2. off to track campaign note changes')
  changed_campaign_notes = trackCampaignNoteChanges({
    campaign_note: track_campaign_note,
    original_campaign_notes,
    changed_campaign_notes,
    character_id,
  })
  //------------------------------------------
  // create new character campaign note entry
  //------------------------------------------
  console.log('3. off to create new character campaign note entry')
  console.log('3.1 updated_at = ', updated_at)
  console.log('3.2 note = ', note)
  let new_campaign_note = createNewCharacterCampaignNoteEntry({
    id: track_campaign_note.id, // temp id used for tracking
    updated_at: updated_at,
    note: note,
    character: character,
  })
  //-----------------------------------------------
  // add campaign note to character campaign notes
  //-----------------------------------------------
  if (!Array.isArray(character.campaign_notes)) {
    character.campaign_notes = []
  }
  character.campaign_notes.push(new_campaign_note)

  // character.campaign_notes.push(new_campaign_note)
  console.log('NEW CAMPAIGN NOTE ADDED TO CHARACTER = ', new_campaign_note)
  console.log('NEW character.campaign_notes = ', character.campaign_notes)
  //------------------------
  // return mutated objects
  //------------------------
  console.log('completed processAddCampaignNote new campaign note = ', new_campaign_note)
  return { changed_campaign_notes, new_campaign_note, character }
}
